import SingleLineText from './SingleLineText';
import MultilineText from './MultilineText';
import NumberField from './Number';
import RichText from './RichText';
import Formula from './Formula';
import Checkbox from './Checkbox';
import SingleSelect from './SingleSelect';
import MultiSelect from './MultiSelect';
import Email from './Email';
import Url from './Url';
import Percent from './Percent';
import Currency from './Currency';
import DateField from './Date';
import DateTimeField from './DateTime';
import Phone from './Phone';
import Created from './Created';
import Rollup from './Rollup';
import Count from './Count';
import AutoNumber from './AutoNumber';
import BarCode from './BarCode';
import Rating from './Rating';
import Duration from './Duration';
import LastModified from './LastModified';
import Button from './Button';
import CreatedBy from './CreatedBy';
import LastModifiedBy from './LastModifiedBy';
import Lookup from './Lookup';
import Attachments from './Attachments';
import MultiCollabs from './MultiCollabs';
import SingleCollab from './SingleCollab';
import RecordLinks from './RecordLinks';
import {FIELD_TYPES} from "../../data";
import {getAPIVersion} from "../../helpers/getAirtableMetaAPIVersion";
const ft = FIELD_TYPES(getAPIVersion());
export const AirtableFields = {
  [ft.FT_SINGLE_LINE]: SingleLineText,
  [ft.FT_EMAIL]: Email,
  [ft.FT_URL]: Url,
  [ft.FT_MULTI_LINES]: MultilineText,
  [ft.FT_RICH_TEXT]: RichText,
  [ft.FT_NUMBER]: NumberField,
  [ft.FT_PERCENT]: Percent,
  [ft.FT_CURRENCY]: Currency,
  [ft.FT_SINGLE_SELECT]: SingleSelect,
  [ft.FT_MULTI_SELECTS]: MultiSelect,
  [ft.FT_SINGLE_COLLAB]: SingleCollab,
  [ft.FT_MULTI_COLLABS]: MultiCollabs,
  [ft.FT_RECORD_LINKS]: RecordLinks,
  [ft.FT_DATE]: DateField,
  [ft.FT_DATETIME]: DateTimeField,
  [ft.FT_PHONE]: Phone,
  [ft.FT_ATTACHMENTS]: Attachments,
  [ft.FT_CHECKBOX]: Checkbox,
  [ft.FT_FORMULA]: Formula,
  [ft.FT_CREATED]: Created,
  [ft.FT_ROLLUP]: Rollup,
  [ft.FT_COUNT]: Count,
  [ft.FT_LOOKUP]: Lookup,
  [ft.FT_AUTONUMBER]: AutoNumber,
  [ft.FT_BARCODE]: BarCode,
  [ft.FT_RATING]: Rating,
  [ft.FT_DURATION]: Duration,
  [ft.FT_LAST_MODIFIED]: LastModified,
  [ft.FT_BUTTON]: Button,
  [ft.FT_CREATED_BY]: CreatedBy,
  [ft.FT_LAST_MODIFIED_BY]: LastModifiedBy,
};

export default AirtableFields;
